module.exports = __webpack_public_path__ + "components/flag/static/square/mz-2e34747c7f4310a0aa4eed380a27ad9e.svg";